// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a4Iz","textarea":"styles_textarea__2EksY"};